// extracted by mini-css-extract-plugin
export default {"salesTable":"SalesPage_salesTable__VCBCg"};